import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { mediaUrl } from "@/lib/api";
import useReveal from "@/hooks/useReveal";
import { Mail, Linkedin } from "lucide-react";

export default function TeamPage() {
  const [team, setTeam] = useState([]);
  const ref = useReveal();

  useEffect(() => {
    api.get("/team/public").then((r) => setTeam(r.data || [])).catch(() => {});
  }, []);

  return (
    <div ref={ref} className="pt-44 lg:pt-56 pb-32" data-testid="team-page">
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-4"><div className="eyebrow">The team · {team.length} people</div></div>
          <div className="col-span-12 md:col-span-8">
            <h1 className="font-heading font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
              The people behind
              <br />
              the practice.
            </h1>
          </div>
        </div>

        {team.length === 0 ? (
          <div className="text-stone py-20 font-mono text-sm" data-testid="team-empty">No team members yet.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-16">
            {team.map((m) => (
              <div key={m.id} data-testid={`team-member-${m.id}`} className="reveal">
                <div className="zoom-wrap aspect-[3/4] bg-sand">
                  <img src={mediaUrl(m.photo_url)} alt={m.full_name} className="zoom-img w-full h-full object-cover" />
                </div>
                <div className="mt-5">
                  <div className="eyebrow text-stone mb-2">{m.department}</div>
                  <h3 className="font-heading text-2xl tracking-tight">{m.full_name}</h3>
                  <div className="text-sm text-stone">{m.job_title}</div>
                  {m.biography && <p className="mt-3 text-sm leading-relaxed text-ink/80">{m.biography}</p>}
                  {m.qualifications && (
                    <div className="mt-3 font-mono text-xs uppercase tracking-widest text-stone">{m.qualifications}</div>
                  )}
                  <div className="mt-4 flex items-center gap-3">
                    {m.email && (
                      <a href={`mailto:${m.email}`} className="text-ink/70 hover:text-ink" aria-label="Email">
                        <Mail size={16} />
                      </a>
                    )}
                    {m.linkedin_url && (
                      <a href={m.linkedin_url} target="_blank" rel="noreferrer" className="text-ink/70 hover:text-ink" aria-label="LinkedIn">
                        <Linkedin size={16} />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
